const CONTROLLER = '/members/:user_id/experiences';
const PATHS = {
  CREATE_EXPERIENCE: '',
  GET_ALL_USER_EXPERIENCES: '',
  FIND_EXPERIENCE_BY_ID: '/:exp_id',
  MODIFY_EXPERIENCE: '/:exp_id',
  REMOVE_EXPERIENCE: '/:exp_id',
};

export const ExperiencesApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k]),
) as {
  [K in keyof typeof PATHS]: K;
};

export const ExperiencesApiRoutes = {
  CONTROLLER,
  PATHS,
  CREATE_EXPERIENCE: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.CREATE_EXPERIENCE}`.replace(
      ':user_id',
      String(user_id),
    ),
  GET_ALL_USER_EXPERIENCES: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_ALL_USER_EXPERIENCES}`.replace(
      ':user_id',
      String(user_id),
    ),
  FIND_EXPERIENCE_BY_ID: (
    user_id: string | undefined,
    exp_id: string | undefined,
  ) =>
    `${CONTROLLER}${PATHS.FIND_EXPERIENCE_BY_ID}`
      .replace(':user_id', String(user_id))
      .replace(':exp_id', String(exp_id)),
  MODIFY_EXPERIENCE: (
    user_id: string | undefined,
    exp_id: string | undefined,
  ) =>
    `${CONTROLLER}${PATHS.MODIFY_EXPERIENCE}`
      .replace(':user_id', String(user_id))
      .replace(':exp_id', String(exp_id)),

  REMOVE_EXPERIENCE: (
    user_id: string | undefined,
    exp_id: string | undefined,
  ) =>
    `${CONTROLLER}${PATHS.REMOVE_EXPERIENCE}`
      .replace(':user_id', String(user_id))
      .replace(':exp_id', String(exp_id)),
};
